import { toast } from "react-toastify";
import { emailRegex } from "../../utils/postgraphile";

class MailService {
    validateEmail = (email: string) => {
        return String(email).toLowerCase().match(emailRegex);
    };

    addMailValue = (mail: string, src: string[]) => {
        if (mail === "") {
            toast.error("no value assaign");
        } else {
            if (mail) {
                if (this.validateEmail(mail)) {
                    if (!src.includes(mail)) {
                        src.push(mail);
                    }
                }
            }
        }
    };
}

export default new MailService();
